import { Component, OnInit, ViewChild, ElementRef, HostListener, EventEmitter, AfterViewInit, ChangeDetectorRef, ViewEncapsulation} from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { BREADCRUMBS } from 'config';
import { Router } from '@angular/router';
import { AuthenticationService, ValidationService, UtilityService, AdobeAnalyticsService } from 'lib/ng2-sapmp/src/providers';
import { BreadCrumbModel, BreadCrumbService } from 'lib/ng2-sapmp/src/ui-components/breadcrumb';
import { CustomgridComponent } from 'lib/ng2-sapmp/src/ui-components/custom-grid';
import { AccordionComponent, AccordionListComponent } from 'lib/ng2-sapmp/src/ui-components/accordion';
import { InitialService } from './initial-signup.service';
import { InitialSignupModel, MdmDetails } from './initial-signup.modal';

import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { FormConfigurationModel, FormPropertyModel } from 'lib/ng2-sapmp/src/ui-components/form-builder';
import { FormBuilderService } from 'lib/ng2-sapmp/src/ui-components/form-builder/form-builder.service';
import { FormBuilder, FormControl, FormGroup, Validators, ReactiveFormsModule } from '@angular/forms';
import { MobilePivotModel } from 'lib/ng2-sapmp/src/ui-components/mobile-pivot/mobile-pivot.model';
import { TERMSCONDITIONS } from 'config';
import { ConfirmModalPopupModel } from 'lib/ng2-sapmp/src/ui-components/confirm-modal';

declare var logoutCurrentUser: any;
export const ESCAPE_KEY = 27;

@Component({
  selector: 'app-initial-signup',
  providers: [ValidationService, InitialService, FormBuilderService],
  templateUrl: './initial-signup.component.html',
  styleUrls: ['./initial-signup.component.scss'],
  encapsulation: ViewEncapsulation.None 
})
export class InitialSignupComponent implements OnInit {
  header: string;
  isDataAvailable: boolean;
  initModal: boolean;
  showOverviewModal: boolean;
  permissionLevelMessage: string;
  eventEmit: any;
  modalClass: string;
  focusabbleElements: any;
  faqDetails: any;
  helpArticles: any;
  isMobile: boolean;
  errorMessage: any;
  signUpStatus: any;
  initialModel: InitialSignupModel;
  mdmDetails: MdmDetails;

  tcUrl: any;
  //tcUrlIbm: any;
  staticTcUrl: any;
  legalIbm: boolean;
  legalZtp: boolean;
  legalKme: boolean;
  userSelection: any; // UserSelectionModel
  selectMdm: FormGroup;
  errorMsg = '';
  breadCrumbs: BreadCrumbModel[];
  previousRoute: any;
  pivots: Array<MobilePivotModel>;
  csrPermissionSignUpButton: boolean;
  showGoogleCreationError: any;
  setupError = false;
  numericSearch: boolean;
  selectedMdmDetails: any;
  selectedAccID: any;
  emmProductCode: any;
  preSelectedMdmselect: any;
  preSelectedMdmDetail: any;
  preSelectedMdm = false;
  preSelectedMdmIbm = false;
  pereSelGoogleValue: any;
  googleValue: any;
  samsungValue: any;
  isSamsungDisable = false;
  isGoogleDisable = false;
  selectedRadio: boolean;
  //selectedRadioIBM: boolean;
  selectedRadioGoogle: boolean;
  selectedRadioSamsung: boolean;
  userDetail: any; // for demo purpose till the backend service is ready.
  productSignupStatus: any;
  otherProductsSelection: any;
  parentemmAccountId: any;
  childemmAccountId: any;
  selectedDetails: any;
  selectedDetailsKme: any;
  signupEmmStatus: any;
  selectedValuesSession: any;
  tncUrl: string;
  manageProduct: any;
  sessionMdmDetails: any;
  preSelectedEmm: any;
  fanProductData: any;
  callSamsung: boolean = true;
  productSelectionStatus: any; // can be any of these 3 newSetupFanList ,revisedFanList ,awaitingSignupFanList
  showZTPProductInfoModal: boolean = false;
  showKMEProductInfoModal: boolean = false;
  confirmModalPopup: ConfirmModalPopupModel;
  public : ConfirmModalPopupModel;
  public showZTPProductInfoPopup: ConfirmModalPopupModel;
  public showKMEProductInfoPopup: ConfirmModalPopupModel;

  // till the back and service is ready we wil be mocking the data

  // setValue() { this.MdmSelection = 'true'; }
  @ViewChild('accessModal') accessModal: ElementRef;

  modelSelection = { MdmSelectionOptions: 'Google' };
  formErrors = {
    'googleIdName': '',
    'samsungIdName': '',
    'googleId': '',
    'samsungId': '',
    'MdmSelection': ''
  };

  validationMessages = {
    'googleIdName': {
      'required': 'Enter a valid email address',
      'pattern': 'Enter a valid email address or Google ID'
    },
    'samsungIdName': {
      'required': 'Samsung ID is required.',
      'pattern': 'Please enter a valid Samsung ID.'
    }
  };
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    this.mobileView();
  }

  constructor(private cd: ChangeDetectorRef, private utilityService: UtilityService, private router: Router,
    private InitialService: InitialService, private authenticationService:
      AuthenticationService, private breadCrumbService: BreadCrumbService, private el: ElementRef,
    private formBuilder: FormBuilder, private validationService: ValidationService,
    private pageloaderService: PageLoaderService, private adobeAnalyticsService: AdobeAnalyticsService) {
    this.mdmDetails = new MdmDetails();
    this.isDataAvailable = false;
    this.faqDetails = [];
    this.numericSearch = true;
    this.selectedValuesSession = sessionStorage.getItem('savedSelectedDetails');
    this.manageProduct = sessionStorage.getItem('manage-product');
    this.selectedValuesSession = JSON.parse(this.selectedValuesSession);
    this.manageProduct = JSON.parse(this.manageProduct);
    this.sessionMdmDetails = JSON.parse(sessionStorage.getItem('mdmDetails'));
    }

  ngOnInit() {
    // document.title = 'Product selection';
    
    document.title = this.utilityService.getPageTitleConfig()[this.router.routerState.snapshot.url];
    this.breadCrumbService.setStaticBreadCrumbs(this.router.routerState.snapshot.url);
    this.breadCrumbService.setCurrentBreadCrumb({ label: 'Product selection', routerLink: '/productselection' });
    this.helpArticles = [{ id: 1, isActive: !this.isMobile, category: 'Help', content: '' }];
    this.InitialService.getInitialDetails().subscribe(response => {
      this.initialModel = response;
      this.initialModel.KmeId = response.productSelection.KmeId;
      this.initialModel.ZtpId = response.productSelection.ZtpId;
      this.isDataAvailable = true;
      this.showZTPProductInfoPopup = new ConfirmModalPopupModel();
      
      this.showZTPProductInfoPopup.modalHeader = response.productSelection.ztpSupportArticleHeader; //'Samsung Knox Mobile Enrollment';
      this.showZTPProductInfoPopup.modalMessage = response.productSelection.ztpSupportArticleMessage; //'Samsung Message';
      this.showZTPProductInfoPopup.showCancelButton = false;
      this.showKMEProductInfoPopup = new ConfirmModalPopupModel();
      this.showKMEProductInfoPopup.modalHeader = response.productSelection.kmeSupportArticleHeader; //'Android zero-touch ';
      this.showKMEProductInfoPopup.modalMessage = response.productSelection.kmeSupportArticleMessage; //'Android Message';
      this.showKMEProductInfoPopup.showCancelButton = false;
     });
    this.staticTcUrl = TERMSCONDITIONS.URL.commonUrl;
    this.tcUrl = TERMSCONDITIONS.URL.addpmdmUrl;
    //this.tcUrlIbm = TERMSCONDITIONS.URL.commonUrl3;
    this.legalZtp = true;
    this.legalKme = true;
    this.legalIbm = false;
    // this.errorMessage = false;
    this.buildForm();
    this.signUpStatus = '';
  }

  ngAfterViewChecked(){ 
    if( this.isDataAvailable && document.getElementById('sId') ){
      this.isDataAvailable = false;
      if (this.selectedValuesSession === null && this.sessionMdmDetails === null) {
        this.initialProductSelectionDetails();
        //document.getElementById('ibmId').click();
      } else if (this.selectedValuesSession === null && this.sessionMdmDetails) { 
        this.preSelectProductDetails();
      } else { 
        this.checkPermission('google');
        this.checkPermission('samsung');
        this.googleValue = this.selectedValuesSession.enteredGoogleValue;
        this.signupEmmStatus = 'initial';
        if (this.selectedValuesSession.selectedSamsungValue !== null && this.selectedValuesSession.selectedSamsungValue !== '') { 
          this.selectedDetailsKme = this.selectedValuesSession.selectedSamsungValue;
        }
          document.getElementById('gId').click();
      }
      if( this.sessionMdmDetails.samsungEmmAccountId ){
        this.callSamsung = false;  
      }
    }
  }

  initialProductSelectionDetails() {
    this.mdmDetails.emmProductCode = '';
    this.mdmDetails.signupStatus = 'initial';
    this.mdmDetails.emmAccountId = '';
    this.mdmDetails.otherProducts[0] = { 'emmProductCode': '', 'signupStatus': '', 'emmAccountId': '' };
    this.userDetail = this.mdmDetails;
    this.setupError = false;
    this.signupEmmStatus = 'initial';
    this.preSelectedMdmselect = '';
    this.productSelectionStatus = '';
    this.preSelectedMdmDetail = this.preSelectedMdmselect;
    this.productSignupStatus = this.productSelectionStatus;
    this.parentemmAccountId = '';
    this.otherProductsSelection = '';
    this.childemmAccountId = '';
    this.checkPermission('google');
    this.checkPermission('samsung');
  }
  preSelectProductDetails() {
    const sessionData = JSON.parse(sessionStorage.getItem('mdmDetails'));
    if (sessionData) {
      if (sessionData.productCode !== 'ADDPMDM') {
        if (sessionData.samsungEmmAccountId && sessionData.googleEmmAccountId) {
          // Mix ZTE
          // Google - User 3
          this.callSamsung = false;
          if (sessionData.latestAccountType === 'DMPGZTP') {
            this.mdmDetails.emmProductCode = 'DMPGZTP';
            this.mdmDetails.signupStatus = 'revised';
            this.mdmDetails.emmAccountId = sessionData.googleEmmAccountId;
            this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'revised', 
            'emmAccountId': sessionData.samsungEmmAccountId };
          } else {
            // Samsung  - User 5
            this.mdmDetails.emmProductCode = 'DMPSKME';
            this.mdmDetails.signupStatus = 'revised';
            this.mdmDetails.emmAccountId = sessionData.samsungEmmAccountId;
            this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'revised', 
            'emmAccountId': sessionData.googleEmmAccountId };
          }
        } else if (sessionData.samsungEmmAccountId) {
          // Samsung  - User 6
          this.callSamsung = false;
          this.mdmDetails.emmProductCode = 'DMPSKME';
          this.mdmDetails.signupStatus = 'revised';
          this.mdmDetails.emmAccountId = sessionData.samsungEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPGZTP', 'signupStatus': 'initial', 'emmAccountId': '' };
        } else {
          // Google - User 4

          this.mdmDetails.emmProductCode = 'DMPGZTP';
          this.mdmDetails.signupStatus = 'revised';
          this.mdmDetails.emmAccountId = sessionData.googleEmmAccountId;
          this.mdmDetails.otherProducts[0] = { 'emmProductCode': 'DMPSKME', 'signupStatus': 'initial', 'emmAccountId': '' };
        }
      }
    } else {
      // Very Initial Case  - User 1

      this.mdmDetails.emmProductCode = '';
      this.mdmDetails.signupStatus = 'initial';
      this.mdmDetails.emmAccountId = '';
      this.mdmDetails.otherProducts[0] = { 'emmProductCode': '', 'signupStatus': '', 'emmAccountId': '' };
    }
    this.userDetail = this.mdmDetails;
    if (this.userDetail) {
      this.preSelectedMdmselect = this.userDetail.emmProductCode;
      this.productSelectionStatus = this.userDetail.signupStatus;
      // this.otherProductsSelection = this.userDetail.otherProducts[0].signupStatus;
      this.preSelectedMdmDetail = this.preSelectedMdmselect;
      this.productSignupStatus = this.productSelectionStatus;
      this.parentemmAccountId = this.userDetail.emmAccountId;
      this.checkPermission('google');
      this.checkPermission('samsung');
      // this.childemmAccountId = this.userDetail.otherProducts[0].emmAccountId;
      if (this.userDetail.otherProducts.length === 0) {
        this.otherProductsSelection = '';
        this.childemmAccountId = '';
      } else {
        this.otherProductsSelection = this.userDetail.otherProducts[0].signupStatus;
        this.childemmAccountId = this.userDetail.otherProducts[0].emmAccountId;
      }
      if (this.userDetail.emmProductCode === 'DMPGZTP' &&
        this.userDetail.signupStatus === 'revised' && this.isGoogleDisable === false) {
        this.selectedRadioGoogle = true;
        this.parentemmAccountId = this.userDetail.emmAccountId;
        this.selectedDetails = this.parentemmAccountId;
        this.signupEmmStatus = 'revised';
        if (this.parentemmAccountId !== null) {
          this.setupError = false;
        }

        if (this.otherProductsSelection === 'revised') {
          this.selectedDetailsKme = this.childemmAccountId;
        }
          //(<HTMLInputElement>document.getElementById('ibmId')).disabled = true;
          //document.getElementById('ibmIdLabel').classList.add('disableLabel');
          document.getElementById('nonMdm').style.color = '#000000';
          document.getElementById('oem').style.color = '#000000';
          //document.getElementById('changeNonIBM').style.display = 'inline-block';
          document.getElementById('selectedDetailsKme').style.display = 'none';
          document.getElementById('selectedDetails').style.display = 'inline-block';
          document.getElementById('selectedDetails').innerHTML = this.initialModel.ZtpId + this.selectedDetails;
          document.getElementById('gId').click();
      } else if (this.userDetail.emmProductCode === 'DMPSKME' &&
        this.userDetail.signupStatus === 'revised' && this.isSamsungDisable === false) {
        this.selectedRadioSamsung = true;
        this.parentemmAccountId = this.userDetail.emmAccountId;
        this.selectedDetailsKme = this.parentemmAccountId;
        this.signupEmmStatus = 'revised';
        if (this.parentemmAccountId !== null) {
          this.setupError = false;
        }
        if (this.otherProductsSelection === 'revised') {
          this.selectedDetails = this.childemmAccountId;
        }
          //(<HTMLInputElement>document.getElementById('ibmId')).disabled = true;
          //document.getElementById('ibmIdLabel').classList.add('disableLabel');
          document.getElementById('nonMdm').style.color = '#000000';
          document.getElementById('oem').style.color = '#000000';
          //document.getElementById('changeNonIBM').style.display = 'inline-block';
          document.getElementById('selectedDetails').style.display = 'none';
          document.getElementById('selectedDetailsKme').style.display = 'inline-block';
          document.getElementById('selectedDetailsKme').innerHTML = this.initialModel.KmeId + this.selectedDetailsKme;
          document.getElementById('sId').click();
      } 
    }
  }
  buildForm(): void {
    this.selectMdm = this.formBuilder.group({
      'googleIdName': ['', [Validators.required, Validators.
        pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]],
      'samsungIdName': ['', [Validators.required, Validators.pattern(/(^[0-9]{1,100}$)+$/)]],
      'MdmSelection': ['', [Validators.required, Validators.pattern(/(?!^\s+$)^.+$/)]]
    });
    this.validationService.validate(
      this.selectMdm,
      this.formErrors,
      this.validationMessages
    );
  }

  /*check mobile view for support article accordion*/
  mobileView() {
    this.helpArticles = [{ id: 1, isActive: !this.isMobile, category: 'Help', content: '' }];
  }

  onChange($event) {

    this.selectMdm.get('googleIdName').setValidators(null);
    this.selectMdm.get('googleIdName').updateValueAndValidity();
    this.selectMdm.get('samsungIdName').setValidators([Validators.required, Validators.pattern(/(^[0-9]{1,100}$)+$/)]);
    this.selectMdm.get('samsungIdName').updateValueAndValidity();
    this.selectMdm.get('MdmSelection').setValidators([Validators.required, Validators.pattern(/(?!^\s+$)^.+$/)]);
    this.selectMdm.get('MdmSelection').updateValueAndValidity();

    if ($event.target.value === 'on') { 
    this.errorMessage = false;  
    //this.legalIbm = true;
    this.legalZtp = true;
    this.legalKme = false;
      this.el.nativeElement.getElementsByClassName('product-brief-link-ztp')[0].style.display = 'none';
      this.el.nativeElement.getElementsByClassName('product-brief-link-kme')[0].style.display = 'inline-block';
      if (this.selectedValuesSession !== null) {
        this.setupError = false;
        sessionStorage.removeItem('showGoogleCreationError');
        document.getElementById('googleId').style.display = 'none';
        this.signupEmmStatus = 'initial';
        this.el.nativeElement.getElementsByClassName('gtooltip')[0].style.display = 'none';
        if (this.selectedDetailsKme != null) {
          this.signupEmmStatus = 'revised';
          document.getElementById('selectedDetailsKme').style.display = 'inline-block';
          document.getElementById('selectedDetailsKme').innerHTML = this.initialModel.KmeId + this.selectedDetailsKme;
        } else {
          document.getElementById('samsungId').style.display = 'inline-block';
          this.el.nativeElement.getElementsByClassName('stooltip')[0].style.display = 'inline-block';
        }
      } else {
        document.getElementById('selectedDetailsKme').style.display = 'inline-block';
        document.getElementById('selectedDetailsKme').innerHTML = this.initialModel.KmeId + this.selectedDetailsKme;
        document.getElementById('selectedDetails').style.display = 'none';
        document.getElementById('googleId').style.display = 'none';
        this.el.nativeElement.getElementsByClassName('gtooltip')[0].style.display = 'none';
        this.initialModel.samsungIdName = this.selectMdm.value.samsungIdName;

        if (this.sessionMdmDetails === null || this.productSelectionStatus === 'initial' && this.userDetail.emmProductCode === 'DMPSKME'
          || this.otherProductsSelection === 'initial' && this.userDetail.otherProducts[0].emmProductCode === 'DMPSKME') {
          // If its the initial case for samsung then the input box will appear.So by default button will be disabled as user has to
          // enter some value in the input box to continue.hence, this.setupError = true;  
          this.setupError = true;
          document.getElementById('selectedDetailsKme').style.display = 'none';
          document.getElementById('googleId').style.display = 'none';
          this.el.nativeElement.getElementsByClassName('gtooltip')[0].style.display = 'none';
          document.getElementById('samsungId').style.display = 'inline-block';
          this.el.nativeElement.getElementsByClassName('stooltip')[0].style.display = 'inline-block';
          this.signupEmmStatus = 'initial';
        } else {  // Revised Samsung case.
          this.setupError = false;
          this.signupEmmStatus = 'revised';
          document.getElementById('selectedDetails').style.display = 'none';
          document.getElementById('googleId').style.display = 'none';
          this.el.nativeElement.getElementsByClassName('gtooltip')[0].style.display = 'none';
          document.getElementById('selectedDetailsKme').style.display = 'inline-block';
          document.getElementById('selectedDetailsKme').innerHTML = this.initialModel.KmeId + this.selectedDetailsKme;
          document.getElementById('samsungId').style.display = 'none';
          this.el.nativeElement.getElementsByClassName('stooltip')[0].style.display = 'none';
        }
        this.initialModel.samsungIdName = this.selectMdm.value.samsungIdName;
        this.tcUrl = TERMSCONDITIONS.URL.dmpskmeUrl;
        this.staticTcUrl = TERMSCONDITIONS.URL.commonUrl;
        if (!this.initialModel.samsungIdName && this.setupError) {
          this.setupError = true;
        } else {
          this.setupError = false;
        }
      }
    }

  }

  onChangeGid($event) {

    this.selectMdm.get('googleIdName').setValidators([Validators.required,
    Validators.pattern('^[_A-Za-z0-9-\\+]+(\\.[_A-Za-z0-9-]+)*@[A-Za-z0-9-]+(\\.[A-Za-z0-9]+)*(\\.[A-Za-z]{2,})$')]);
    this.selectMdm.get('googleIdName').updateValueAndValidity();
    this.selectMdm.get('samsungIdName').setValidators(null);
    this.selectMdm.get('samsungIdName').updateValueAndValidity();
    this.selectMdm.get('MdmSelection').setValidators(null);
    this.selectMdm.get('MdmSelection').updateValueAndValidity();

    if ($event.target.value === 'on') {
    this.errorMessage = false; 
    //this.legalIbm = true;
    this.legalZtp = false;
    this.legalKme = true;
      this.el.nativeElement.getElementsByClassName('product-brief-link-kme')[0].style.display = 'none';
      this.el.nativeElement.getElementsByClassName('product-brief-link-ztp')[0].style.display = 'block';
      if (this.selectedValuesSession !== null) {
        const showGoogleCreationError = JSON.parse(sessionStorage.getItem('showGoogleCreationError'));
        if (showGoogleCreationError !== null && showGoogleCreationError !== undefined && showGoogleCreationError === true) {  
          this.errorMessage = 'We were unable to complete your request.' +
            'Please check that you have entered a valid email address or Google ID.';
            this.cd.detectChanges();
          this.utilityService.loadFocusOnTop();
        }
        document.getElementById('selectedDetailsKme').style.display = 'none';
        document.getElementById('selectedDetails').style.display = 'none';
        document.getElementById('googleId').style.display = 'inline-block';
        this.signupEmmStatus = 'initial';
        this.el.nativeElement.getElementsByClassName('gtooltip')[0].style.display = 'inline-block';
        if (this.selectedDetailsKme !== null && this.selectedDetailsKme !== undefined) {
            //(<HTMLInputElement>document.getElementById('ibmId')).disabled = true;
            //document.getElementById('ibmIdLabel').classList.add('disableLabel');
            document.getElementById('nonMdm').style.color = '#000000';
            document.getElementById('oem').style.color = '#000000';
            //document.getElementById('changeNonIBM').style.display = 'inline-block';

        }
      } else {
        document.getElementById('selectedDetails').style.display = 'inline-block';
        document.getElementById('selectedDetails').innerHTML = this.initialModel.ZtpId + this.selectedDetails;
        document.getElementById('selectedDetailsKme').style.display = 'none';
        document.getElementById('samsungId').style.display = 'none';
        this.el.nativeElement.getElementsByClassName('stooltip')[0].style.display = 'none';
        this.initialModel.googleIdName = this.selectMdm.value.googleIdName;

        if (this.sessionMdmDetails === null || this.productSelectionStatus === 'initial' && this.userDetail.emmProductCode === 'DMPGZTP'
          || this.otherProductsSelection === 'initial' && this.userDetail.otherProducts[0].emmProductCode === 'DMPGZTP') {
          // Google initial case
          this.setupError = true;
          document.getElementById('selectedDetails').style.display = 'none';
          document.getElementById('googleId').style.display = 'inline-block';
          this.el.nativeElement.getElementsByClassName('gtooltip')[0].style.display = 'inline-block';
          document.getElementById('samsungId').style.display = 'none';
          this.el.nativeElement.getElementsByClassName('stooltip')[0].style.display = 'none';
          this.signupEmmStatus = 'initial';
        } else {  // Google Revised
          this.setupError = false;
          this.signupEmmStatus = 'revised';
          document.getElementById('selectedDetails').style.display = 'none';
          document.getElementById('samsungId').style.display = 'none';
          this.el.nativeElement.getElementsByClassName('stooltip')[0].style.display = 'none';
          document.getElementById('selectedDetails').style.display = 'inline-block';
          document.getElementById('selectedDetails').innerHTML = this.initialModel.ZtpId + this.selectedDetails;
          document.getElementById('googleId').style.display = 'none';
          this.el.nativeElement.getElementsByClassName('gtooltip')[0].style.display = 'none';
        }
        this.tcUrl = TERMSCONDITIONS.URL.dmpgztpUrl;
        this.staticTcUrl = TERMSCONDITIONS.URL.commonUrl;
      }
      if (!this.initialModel.googleIdName && this.setupError) {
        this.setupError = true;
      } else {
        this.setupError = false;
      }
    }

  }

  checkPermission(field) {  
    const permission = JSON.parse(sessionStorage.getItem('permissions'));
    if (permission !== 'null') {
      if (!this.utilityService.checkComponentPermission(field, permission.perm)) {
        if (field === 'samsung') {
          this.isSamsungDisable = true;
        } else {
          this.isGoogleDisable = true;
        }
      }
    }
  }

  // onChangeIBM($event) {

  //   this.selectMdm.get('googleIdName').setValidators(null);
  //   this.selectMdm.get('googleIdName').updateValueAndValidity();
  //   this.selectMdm.get('samsungIdName').setValidators(null);
  //   this.selectMdm.get('samsungIdName').updateValueAndValidity();
  //   this.selectMdm.get('MdmSelection').setValidators([Validators.required, Validators.pattern(/(?!^\s+$)^.+$/)]);
  //   this.selectMdm.get('MdmSelection').updateValueAndValidity();

    
  //   if ($event.target.value = 'on') {
  //   this.errorMessage = false;  
  //   //this.legalIbm = false;
  //   this.legalZtp = true;
  //   this.legalKme = true;
  //     this.el.nativeElement.getElementsByClassName('googleId')[0].style.display = 'none';
  //     this.el.nativeElement.getElementsByClassName('samsungId')[0].style.display = 'none';
  //     this.el.nativeElement.getElementsByClassName('product-brief-link-ztp')[0].style.display = 'none';
  //     this.el.nativeElement.getElementsByClassName('product-brief-link-kme')[0].style.display = 'none';
  //     this.tcUrl = TERMSCONDITIONS.URL.addpmdmUrl;
  //     this.tcUrlIbm = TERMSCONDITIONS.URL.commonUrl3;
  //     this.staticTcUrl = TERMSCONDITIONS.URL.commonUrl;
  //     this.setupError = false;
  //   }

  // }

  onChangeText($event) { 
    this.setupError = false;
    //this.legalIbm = true;
    //this.legalZtp = false;
    //this.legalKme = true;
    $event = Object($event);
    if (this.googleValue === '' || this.googleValue === null) {  
      this.setupError = true;
    } else if (this.showGoogleCreationError === true || this.selectedValuesSession.enteredGoogleValue === this.googleValue) {
      this.errorMessage = 'We were unable to complete your request. Please check that you' +
      ' have entered a valid email address or Google ID.';
      this.utilityService.loadFocusOnTop();
    } else if (this.selectedValuesSession.enteredGoogleValue !== this.googleValue) { 
          this.signupEmmStatus = 'initial';
          this.setupError = false;
          this.errorMessage = false;
    } 
  }


  onChangeTextNum($event) {
    this.setupError = false;
    // this.legalIbm = true;
    // this.legalZtp = true;
    // this.legalKme = false;
    $event = Object($event);
    if (this.samsungValue === '' || this.samsungValue === null) {
      this.setupError = true;
    } else {
      this.signupEmmStatus = 'initial';
      this.setupError = false;
      this.errorMessage = false;  
    }
  }

  keyValidation(event) {
    event = Object(event);
    if (event) {
      this.setupError = false;
    } else {
      this.setupError = true;
    }
  }

  onlyNumberKey(event) {
    event = Object(event);
    if (event) {
      if (event.code === 'Digit' + event.key) {
        this.setupError = false;
      }
    } else {
      this.setupError = true;
    }
    // return (event.charCode == 8 || event.charCode == 0) ? null : event.charCode >= 48 && event.charCode <= 57;
  }

  cancel() {
    this.router.navigate(['/dashboard']);
  }

  getStyle() {
    this.checkPermission('google');
    this.checkPermission('samsung');
    // if (this.preSelectedMdmDetail === 'ADDPMDM') {
    //   this.preSelectedMdm = true;
    //   this.setupError = false;
    //   //this.legalIbm = false;
    //   this.tcUrl = TERMSCONDITIONS.URL.addpmdmUrl;
    //   this.el.nativeElement.getElementsByClassName('changeIBM')[0].style.display = 'inline-block';
    //   this.el.nativeElement.getElementsByClassName('sId')[0].setAttribute('disabled', 'true');
    //   this.el.nativeElement.getElementsByClassName('gId')[0].setAttribute('disabled', 'true');
    //   document.getElementById('sIdLabel').classList.add('disableLabel');
    //   document.getElementById('gIdLabel').classList.add('disableLabel');
    //   this.el.nativeElement.getElementsByClassName('mdm')[0].style.color = '#000000';
    //   return '#757575';
    // } else 
    if (this.preSelectedMdmDetail === 'DMPGZTP' && this.isGoogleDisable === false) {
      //this.preSelectedMdmIbm = true;
      this.setupError = false;
      //this.legalIbm = true;
      this.legalZtp = false;
      this.legalKme = true;
      this.selectedRadioGoogle = true;
      this.selectedRadioSamsung = false;
      this.selectedDetails = this.parentemmAccountId;
      this.tcUrl = TERMSCONDITIONS.URL.dmpgztpUrl;
      //this.el.nativeElement.getElementsByClassName('ibmId')[0].setAttribute('disabled', 'true');
      //document.getElementById('ibmIdLabel').classList.add('disableLabel');
      this.el.nativeElement.getElementsByClassName('nonMdm')[0].style.color = '#000000';
      this.el.nativeElement.getElementsByClassName('oem')[0].style.color = '#000000';
      // this.el.nativeElement.getElementsByClassName('selectedDetails')[0].style.display = 'inline-block';
      //this.el.nativeElement.getElementsByClassName('changeNonIBM')[0].style.display = 'inline-block';
      this.el.nativeElement.getElementsByClassName('googleId')[0].style.display = 'none'; // revised the input on click if it is revised
      if (this.otherProductsSelection !== 'initial') {
        this.selectedDetailsKme = this.childemmAccountId;
        this.initialModel.MdmSelection = this.preSelectedMdmDetail;
        this.selectedAccID = this.parentemmAccountId;
        // this.el.nativeElement.getElementsByClassName('selectedDetailsKme')[0].style.display = 'inline-block';
        this.el.nativeElement.getElementsByClassName('samsungId')[0].style.display = 'none'; // revised the input on click if it is revised
      } else {
        this.selectedDetailsKme = this.childemmAccountId;
        // this.el.nativeElement.getElementsByClassName('samsungId')[0].style.display = 'inline-block';
      }
      return '#757575';

    } else if (this.preSelectedMdmDetail === 'DMPSKME' && this.isSamsungDisable === false) {
      //this.preSelectedMdmIbm = true;
      this.setupError = false;
      //this.legalIbm = true;
      this.legalZtp = true;
      this.legalKme = false;
      this.selectedRadioGoogle = false;
      this.selectedRadioSamsung = true;
      this.selectedDetailsKme = this.parentemmAccountId;
      this.tcUrl = TERMSCONDITIONS.URL.dmpskmeUrl;
      //this.el.nativeElement.getElementsByClassName('ibmId')[0].setAttribute('disabled', 'true');
      //document.getElementById('ibmIdLabel').classList.add('disableLabel');
      this.el.nativeElement.getElementsByClassName('oem')[0].style.color = '#000000';
      this.el.nativeElement.getElementsByClassName('nonMdm')[0].style.color = '#000000';
      //this.el.nativeElement.getElementsByClassName('changeNonIBM')[0].style.display = 'inline-block';
      // this.el.nativeElement.getElementsByClassName('selectedDetailsKme')[0].style.display = 'inline-block';
      this.el.nativeElement.getElementsByClassName('samsungId')[0].style.display = 'none'; // revised the input on click if it is revised
      if (this.otherProductsSelection !== 'initial') {
        this.selectedDetails = this.childemmAccountId;
        // this.el.nativeElement.getElementsByClassName('selectedDetails')[0].style.display = 'inline-block';
        this.el.nativeElement.getElementsByClassName('googleId')[0].style.display = 'none'; // revised the input on click if it is revised
      } else {
        this.selectedDetails = this.childemmAccountId;
        // this.el.nativeElement.getElementsByClassName('googleId')[0].style.display = 'inline-block';
      }
      return '#757575';
    } else {
      this.preSelectedMdm = false;
      return '';
    }
  }

  signupSubmit() {
    this.pageloaderService.setPageLoaderStatus(false);
    if (this.selectMdm.dirty) {
      this.initialModel.googleIdName = this.selectMdm.value.googleIdName || this.selectedDetails;
      this.initialModel.samsungIdName = this.selectMdm.value.samsungIdName || this.selectedDetailsKme;
      this.initialModel.MdmSelection = this.selectMdm.value.MdmSelection;
      // if (this.initialModel.MdmSelection === 'ADDPMDM') {
      //   this.selectedAccID = '';
      // } else 
      if (this.initialModel.MdmSelection === 'DMPGZTP') {
        this.selectedAccID = this.initialModel.googleIdName;
      } else {
        this.selectedAccID = this.initialModel.samsungIdName;
      }
    } else {
      if (this.preSelectedMdmDetail === 'DMPGZTP') {
        this.initialModel.MdmSelection = this.preSelectedMdmDetail;
        this.selectedAccID = this.selectedDetails;
      } else if (this.preSelectedMdmDetail === 'DMPSKME') {
        this.initialModel.MdmSelection = this.preSelectedMdmDetail;
        this.selectedAccID = this.selectedDetailsKme;
      } 
      // else {
      //   this.initialModel.MdmSelection = 'ADDPMDM';
      //   if (this.otherProductsSelection !== 'initial') {
      //     this.selectedAccID = '';
      //   }
      // }
    }
    this.selectedMdmDetails = this.initialModel.MdmSelection;

    let productDetails = { emmProductCode: '', selectedAccID: '', signupEmmStatus: '' };
    productDetails.emmProductCode = this.selectedMdmDetails;
    productDetails.selectedAccID = this.selectedAccID;
    productDetails.signupEmmStatus = this.signupEmmStatus;
    if (this.selectedValuesSession != null) {
      // if (this.selectedValuesSession.preSelectedEmm === '' && this.selectedMdmDetails === 'ADDPMDM') {
      //   productDetails.signupEmmStatus = 'initial';
      // }
      // if (this.selectedValuesSession.preSelectedEmm === 'ADDPMDM' && this.selectedMdmDetails === 'ADDPMDM') {
      //   productDetails.signupEmmStatus = 'revised';
      // }
      if (this.selectedValuesSession.preSelectedEmm === 'DMPGZTP' && this.selectedMdmDetails === 'DMPSKME'
        && this.selectedValuesSession.childStatus === 'initial') {
        productDetails.signupEmmStatus = 'initial';
      }
      if (this.selectedValuesSession.preSelectedEmm === 'DMPSKME' && this.selectedMdmDetails === 'DMPGZTP' &&
        this.selectedValuesSession.childStatus === 'initial') {
        productDetails.signupEmmStatus = 'initial';
      }
    } else {
      productDetails.signupEmmStatus = this.signupEmmStatus;
    }
    sessionStorage.setItem('manage-product', JSON.stringify(productDetails));
    if (this.signupEmmStatus === 'initial' && this.selectedMdmDetails === 'DMPGZTP') {
      let selectedValue = { enteredGoogleValue: '', selectedSamsungValue: '' };
      selectedValue.enteredGoogleValue = this.initialModel.googleIdName;
      if (this.selectedDetailsKme !== null && this.selectedDetailsKme !== undefined) {
        selectedValue.selectedSamsungValue = this.selectedDetailsKme;
      }
      sessionStorage.setItem('savedSelectedDetails', JSON.stringify(selectedValue));
    }
    sessionStorage.removeItem('showGoogleCreationError');
    let selectedEmmProductCode = sessionStorage.getItem('manage-product');
    this.emmProductCode = JSON.parse(selectedEmmProductCode).emmProductCode;
    if (this.selectedMdmDetails === 'DMPSKME' && !this.isSamsungDisable ) {
      if (this.callSamsung) {
        this.InitialService.signupDetails(this.emmProductCode, this.selectedAccID)
          .subscribe(response => {
            this.pageloaderService.setPageLoaderStatus(true);
            if (this.initialModel.MdmSelection === 'DMPSKME') {
              if ( response.users && response.users.length !== 0) {
                if (this.selectedAccID !== response.users[0].companyId) {
                  this.errorMessage = 'We were unable to complete your request.' +
                    'Please check that you have entered a valid Samsung Knox Mobile Enrollment ID.';
                  this.setupError = true;
                  this.utilityService.loadFocusOnTop();
                } else {
                  this.setupError = false;
                  this.router.navigate(['/signup/']);
                }
              } else {
                this.errorMessage = 'We were unable to complete your request. ' +
                  'Please check that you have entered a valid Samsung Knox Mobile Enrollment ID.';
                this.setupError = true;
                this.utilityService.loadFocusOnTop();
              }
            } 
            // else if (this.emmProductCode === 'ADDPMDM' || this.emmProductCode === '') {
            //   this.setupError = false;
            //   this.router.navigate(['/signup/']);
            // } 
            else if (this.emmProductCode === 'DMPGZTP' && this.selectedAccID === null || this.selectedAccID === '') {
              this.errorMessage = 'Google Validation error has occured. Please enter valid Email id';
              this.setupError = true;
            } else {
              this.setupError = false;
              this.router.navigate(['/signup/']);
            }
          }, error => {
            this.pageloaderService.setPageLoaderStatus(true);
            this.handleError(error);
          });
      } else {
        this.setupError = false;
        this.router.navigate(['/signup/']);
      }
    } 
    else if (this.selectedMdmDetails === 'DMPGZTP' && !this.isGoogleDisable ) { 
      this.pageloaderService.setPageLoaderStatus(true);
      if (this.emmProductCode === 'DMPGZTP' && this.selectedAccID === null || this.selectedAccID === '') {
        this.errorMessage = 'Google Validation error has occured. Please enter valid Email id';
        this.setupError = true;
      } else {
        this.setupError = false;
        this.router.navigate(['/signup/']);
      }
    }
    // else if (this.selectedMdmDetails === 'ADDPMDM') { 
    //   this.pageloaderService.setPageLoaderStatus(true);
    //   if (this.emmProductCode === 'ADDPMDM' || this.emmProductCode === '') {
    //     this.setupError = false;
    //     this.router.navigate(['/signup/']);
    //   }
    // }
    else {
      this.pageloaderService.setPageLoaderStatus(true);
      this.setupError = true;
    }
  }

  handleError = (err) => {
    let isBusinessRuleError = false;
    if (err) {
      if (err.status === 500) {
        this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
        isBusinessRuleError = true;
      } else if (err.status === 401) {
        this.errorMessage = 'Session expired, Please login again.';
        logoutCurrentUser(true);
      } else if (err.status === 400) {
        this.errorMessage = 'Id is already in the system.';
        isBusinessRuleError = true;
      } else if (err.status === 404) {
        this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
        isBusinessRuleError = true;
      } else if (this.signUpStatus === 'failure') { // remove this block after it is integrated wit the servce this is only for demo
        this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
      } else {
        this.errorMessage = "Something went wrong. We couldn't process your request. Please try again later.";
      }
      this.utilityService.loadFocusOnTop();
    }
    if (isBusinessRuleError) {
      this.adobeAnalyticsService.CreateSeriveAlertProperties(err.status, err.statusText, 'formResponse', 'Failure_BusinessRule');
    } else {
      this.adobeAnalyticsService.CreateSeriveAlertProperties(err.status, err.statusText, 'formResponse');
    }
  }
  showZTPProductInfo ()
  {
    this.showZTPProductInfoModal = true;
  }

  closeZTPProductInfoModal ()
  {
    this.showZTPProductInfoModal = false; 
  }
  showKMEProductInfo ()
  {
    this.showKMEProductInfoModal = true;
  }

  closeKMEProductInfoModal ()
  {
    this.showKMEProductInfoModal = false; 
  }
}